import { Component, OnInit } from '@angular/core';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { TranslocoService } from '@ngneat/transloco';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { Router } from '@angular/router';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { TextblockModel } from 'projects/core/src/lib/models/textblock.model';

@Component({
  selector: 'app-textblock-list',
  templateUrl: './textblock-list.component.html',
  styleUrls: ['./textblock-list.component.scss']
})
export class TextblocksListComponent extends BaseList implements OnInit {

  public textblocks: Array<TextblockModel> = [];
  public apiUrl = '/contents/textblocks';

  protected rightLoad = 'admin.textblock.list';
  protected rightNew = 'admin.textblock.create';
  protected rightOpen = 'admin.textblock.show';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    this.loadList();
  }

  loadList(): void {
    this.loading = true;
    this.api.getModels('textblocks').subscribe({
      next: (textblocks: any) => {
        this.textblocks = [];
        textblocks.data.forEach((ac: any) => {
          this.textblocks.push(new TextblockModel().deserialize(ac));
        });
      },
      error: (error: any) => {

      }
    }).add(() => {
      this.loading = false;
    });
  }

}
